export const nl = {
  Klantondersteuning_Formulieren_BijlageIndicatorLabel: "Bijlage",
  Klantondersteuning_Formulieren_BijlagenInfoText: "Maximaal {{maxAmount}} bestanden van 5MB per bestand.",
  Klantondersteuning_Formulieren_BijlageInfoText: "Maximaal {{maxAmount}} bestand van 5MB.",
  Klantondersteuning_Formulieren_NakijkenEnVersturen: "Nakijken en versturen",
  Klantondersteuning_Formulieren_NoPDFButtonFound: "Er is geen PDF gevonden.",
  Klantondersteuning_Formulieren_OpslaanAlsPdf: "Opslaan als PDF",
  Klantondersteuning_Formulieren_RegelingOndersteuningVanuitWmo: "Wet maatschappelijke ondersteuning (Wmo)",
  Klantondersteuning_Formulieren_RegelingZorgVanuitDeWlz: "Wet langdurige zorg (Wlz)",
  Klantondersteuning_Formulieren_RegelingZorgverzekeringEnBuitenland: "Zorgverzekering en buitenland",
  Klantondersteuning_Formulieren_RegelingMedicijnenMeeOpReis: "Medicijnen mee op reis",
  Klantondersteuning_Formulieren_RegelingOnverzekerden: "Regeling onverzekerden",
  Klantondersteuning_Formulieren_RegelingGemoedsbezwaarden: "Regeling gemoedsbezwaarden",
  Klantondersteuning_Formulieren_RegelingBetalingsachterstandZorgpremie: "Betalingsachterstand zorgpremie",
  Klantondersteuning_Formulieren_RegelingGepensioneerdenEnUitkeringsgerechtigden:
    "Regeling gepensioneerden en uitkeringsgerechtigden",
  Klantondersteuning_Formulieren_RegelingEHIC: "EHIC",
  Klantondersteuning_Formulieren_RegelingBeschermdWonen: "Beschermd wonen (Wmo)",
  Klantondersteuning_Formulieren_RegelingCBHC: "Nationaal Contactpunt voor grensoverschrijdende zorg",
  Klantondersteuning_Formulieren_RegelingOnbekend: "Ik weet de regeling niet",
  Klantondersteuning_Formulieren_RegelingOnverzekerbareVreemdelingen: "Regeling onverzekerbare vreemdelingen",
  Klantondersteuning_Formulieren_RegelingSOV:
    "Subsidieregeling medisch noodzakelijke zorg voor onverzekerden",
  Klantondersteuning_Formulieren_UwVraagDownloadenTekst: "Uw ingevulde gegevens bewaren?",
  Klantondersteuning_Formulieren_Verzenden: "Verzenden",
  Klantondersteuning_Formulieren_VoegBestandenToe: "Voeg bestanden toe",
  Klantondersteuning_Formulieren_VoegBestandToe: "Voeg bestand toe",
  Klantondersteuning_Formulieren_FormulierVerstuurd: "Formulier verstuurd",
  "Klantondersteuning_Formulieren_TextAreaInfoText{aantal}":
    "Er kunnen maximaal {{aantal}} tekens ingevoerd worden.",
  Klantondersteuning_Formulieren_Volgende: "Volgende",
  Klantondersteuning_Formulieren_NaarMijnCAKOverzicht: "Naar Mijn CAK Overzicht"
};
